import { Injectable, inject } from '@angular/core';
import { StorageService } from './storage.service';

/** L'essai d'un invité, gardé pour l'inscription : sa commune et ses deux cultures. */
export interface GuestTrial {
  commune: string;
  cultivationUids: string[];
}

export const GUEST_TRIAL_KEY = 'guest-trial';

/**
 * Ce que l'invité a essayé sur l'accueil (« Essaie avec ton jardin ») passe à
 * l'inscription : l'onboarding préremplit la commune et propose ses cultures
 * en premier. Sans stockage, l'essai est simplement oublié.
 */
@Injectable({ providedIn: 'root' })
export class GuestTrialService {
  private readonly storage = inject(StorageService);

  save(trial: GuestTrial): void {
    try {
      this.storage.setItem(GUEST_TRIAL_KEY, JSON.stringify(trial));
    } catch {
      // Stockage refusé : l'inscription repart de zéro.
    }
  }

  read(): GuestTrial | null {
    try {
      const raw = this.storage.getItem(GUEST_TRIAL_KEY);
      const trial = raw ? JSON.parse(raw) : null;
      return trial && typeof trial.commune === 'string' && Array.isArray(trial.cultivationUids) ? trial : null;
    } catch {
      return null;
    }
  }

  /** L'onboarding a repris l'essai : il ne revient plus. */
  clear(): void {
    try {
      this.storage.removeItem(GUEST_TRIAL_KEY);
    } catch {
      // Rien à oublier.
    }
  }
}
